module.exports = __webpack_public_path__ + "static/bg-light-mob-dd63283af071ff5567015123379e0b61.webp";